import { Spin } from 'antd';
import styles from './linkedInStatusTag.module.less';
import { LinkedinFilled, LoadingOutlined } from '@ant-design/icons';

type LinkedInStatusTagProps = {
    status: 'success' | 'warning' | 'error' | 'loading';
    label: string;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
};

export function LinkedInStatusTag({
    status,
    label,
    onMouseEnter,
    onMouseLeave,
}: LinkedInStatusTagProps) {
    const isLoading = status === 'loading';
    return (
        <div className={styles.statusTag} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <LinkedinFilled className={styles.headerIcon} />
            {isLoading ? (
                <Spin indicator={<LoadingOutlined />} />
            ) : (
                <div className={[styles.statusIndicator, styles[status]].join(' ')} />
            )}
            {label}
        </div>
    );
}
